import interpolateRouteUtil from 'modules/routes/utils/interpolate'

function getUrlTrainingDeepLinkUtil (path) {
  // TODO fix in dev: 127.0.0.1:19000/--/
  return `gymaholic-training://${path}`
}

export function navigateTrainingDeepLinkUtil (path, params) {
  window.location = getUrlTrainingDeepLinkUtil(interpolateRouteUtil(path, params))
}
